import { Button } from "@ts-digital/vrc";
import { useLocation, useNavigate } from "react-router-dom";
import Modal from "antd/lib/modal/Modal";
import React from "react";
import LoaderSimple from "../../general/loader";

const TSPayPaymentWaitingModal = props => {
  const {
    childWindow,
    getLogo,    
    paymentResponse,
    selectedBankAccount,
    uuidToCheck
  } = props;

  const location = useLocation();
  const navigate = useNavigate();
  return (
    <Modal
      visible={true}
      closable={false}
      backdrop={false}
      footer={
        <div className="dbx-tspay-payment-waiting-footer">
          <div className="dbx-tspay-payment-waiting-button">
            <Button
              kind="secondary"
              onClick={() => {
                localStorage.removeItem(`tspayPaymentUuidToCheck_${uuidToCheck}`);
                childWindow.close();
                if (location.state.deadlines.length > 1) {
                  navigate("/scadenze");
                } else {
                  navigate("/scadenza/" + location.state.deadlines[0].id);
                }
              }}
            >
              Interrompi
            </Button>
          </div>
        </div>
      }
      className="dbx-tspay-payment-waiting-modal"
      title="Pagamento TS Pay in corso"
    >
      <div className="dbx-tspay-payment-waiting-body">
        <div className="dbx-tspay-payment-waiting-logo">
          {getLogo(selectedBankAccount)}
        </div>
        <div className="dbx-tspay-payment-waiting-text">
          Attenzione, operazione in corso, non chiudere questa pagina.
        </div>
        <div className="dbx-tspay-payment-waiting-loader">
          <LoaderSimple />
        </div>
        <div className="dbx-tspay-payment-waiting-tip1">
          Se chiudi questa finestra il processo di pagamento non verrà
          completato.
        </div>
        <div className="dbx-tspay-payment-waiting-tip2">
          Se non si apre nessuna nuova finestra, probabilmente hai attivato il
          blocco pop up. Disattivalo nel tuo browser e{" "}
          <a href={paymentResponse.scaManagerRedirectUrl} target={"blank"}>
            ricarica la pagina
          </a>
        </div>
      </div>
    </Modal>
  );
};

export default TSPayPaymentWaitingModal;
